var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('ArtworkDetails',{attrs:{"internetAuction":_vm.internetAuction}}),_vm._v(" "),(_vm.auctionStateIsStarted)?_c('BidPanel',{attrs:{"internetAuction":_vm.internetAuction}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6b3a7c0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/internet_auctions/components/modal/auction_content.vue
// module id = 672
// module chunks = 0 1 2 3 4 5 6 7 8 10 15 19 26 29